/**
 * Sincroniza suscripciones del tema con Klaviyo (_learnq + API client de listas).
 * Requiere el app embed de Klaviyo activo o klaviyo_company_id en ajustes del tema.
 */
(function () {
  var CLAVE_CONSENTIMIENTO = 'aviso-cookies-consentimiento';

  function marketingPermitido() {
    try {
      var raw = window.localStorage.getItem(CLAVE_CONSENTIMIENTO);
      if (!raw) return true;
      var datos = JSON.parse(raw);
      return datos && datos.valor === 'aceptado';
    } catch (e) {
      return true;
    }
  }

  function normalizarPreferencia(interesTag) {
    if (!interesTag) return '';
    var mapa = {
      'interes-vestidos': 'Vestidos',
      'interes-conjuntos': 'Conjuntos femeninos',
      'interes-accesorios': 'Accesorios',
      'interes-calzado': 'Botas y botines',
      'interes-encaje': 'Tops de encaje',
    };
    return mapa[interesTag] || interesTag.replace(/^interes-/, '');
  }

  function obtenerCompanyId() {
    var cfg = window.__naiaKlaviyoConfig;
    if (cfg && cfg.companyId) return String(cfg.companyId).trim();
    var script = document.querySelector('script[src*="static.klaviyo.com/onsite/js/"][src*="company_id="]');
    if (!script || !script.src) return '';
    var match = script.src.match(/company_id=([^&]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function identificarLearnq(email, props) {
    window._learnq = window._learnq || [];
    var profile = { $email: email };
    if (props) {
      Object.keys(props).forEach(function (key) {
        if (props[key] != null && props[key] !== '') profile[key] = props[key];
      });
    }
    window._learnq.push(['identify', profile]);
    window._learnq.push([
      'track',
      'Subscribed to Newsletter',
      Object.assign({ source: 'Naia Blanc storefront' }, props || {}),
    ]);
  }

  function suscribirLista(email, companyId, listId, props) {
    if (!listId || !companyId) return Promise.resolve();

    var profileAttrs = { email: email };
    if (props && props.interes) {
      profileAttrs.properties = {
        interes: props.interes,
        preferencia_categoria: normalizarPreferencia(props.interes),
      };
    }

    if (props && props.variante) {
      profileAttrs.properties = profileAttrs.properties || {};
      profileAttrs.properties.popup_variante = props.variante;
    }

    var attrs = {
      custom_source: props && props.source ? props.source : 'Newsletter Naia Blanc',
      profile: {
        data: {
          type: 'profile',
          attributes: profileAttrs,
        },
      },
    };

    if (props && props.marketingConsent) {
      attrs.subscriptions = {
        email: {
          marketing: {
            consent: 'SUBSCRIBED',
          },
        },
      };
    }

    var body = {
      data: {
        type: 'subscription',
        attributes: attrs,
        relationships: {
          list: {
            data: { type: 'list', id: listId },
          },
        },
      },
    };

    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-07-15',
        },
        body: JSON.stringify(body),
      }
    ).catch(function () {});
  }

  window.naiaKlaviyoSuscribir = function (email, options) {
    var cfg = window.__naiaKlaviyoConfig || {};
    if (cfg.enabled === false) return Promise.resolve();

    if (!email) return Promise.resolve();
    var emailNorm = String(email).trim().toLowerCase();
    if (!emailNorm) return Promise.resolve();

    var props = options || {};
    if (props.interes) {
      props.preferencia_categoria = normalizarPreferencia(props.interes);
    }

    var esSuscripcionFormulario =
      props.source && String(props.source).toLowerCase().indexOf('popup') !== -1;

    if (props.requireMarketingConsent && !props.marketingConsent) {
      return Promise.resolve();
    }

    if (!props.marketingConsent) {
      return Promise.resolve();
    }

    if (marketingPermitido()) {
      identificarLearnq(emailNorm, props);
    }

    var companyId = obtenerCompanyId();
    return suscribirLista(emailNorm, companyId, cfg.listId, props);
  };
})();
